import React from 'react';
import styled from 'styled-components';

import { PartnersBooksLink } from '~/atomic/atom/links/staticLinks';
import { openModal } from '~/feature/authorization/authorizationModal.slice';
import { isLoggedInSelector } from '~/feature/user/isLoggedInSelector';
import { lessThan } from '~/lib/mediaQuery';
import { useAppDispatch, useAppSelector } from '~/store';

import { Accordion } from '../im-author/Accordion';

export const Refriver = () => {
  const dispatch = useAppDispatch();
  const isLoggedIn = useAppSelector(isLoggedInSelector);

  return (
    <SCRefriver>
      <SCHeroBlock>
        <SCHeroBlockContent>
          <SCHeroBlockHeaders>
            <SCHeroTitleH1>
              Партнерская программа
            </SCHeroTitleH1>
            <SCHeroTitleH2>
              для авторов, их читателей, владельцев книжных сайтов, групп и блогов
            </SCHeroTitleH2>
          </SCHeroBlockHeaders>
        </SCHeroBlockContent>
      </SCHeroBlock>
      <SCBlock>
        <SCRefRiverRow>
          <SCStatisticsContainer>
            <SCSCStatisticsMain>
              <SCSCStatisticsMainTitle>
                до 40%
              </SCSCStatisticsMainTitle>
              <SCSCStatisticsMainDescription>
                по специальным предложениям от авторов
              </SCSCStatisticsMainDescription>
            </SCSCStatisticsMain>
            <SCSCStatisticsSecond>
              <SCSCStatisticsSecondTitle>
                10%
              </SCSCStatisticsSecondTitle>
              <SCSCStatisticsSecondDescription>
                всегда и с любой книги на сайте
              </SCSCStatisticsSecondDescription>
            </SCSCStatisticsSecond>
          </SCStatisticsContainer>
          <SCAuthorsSupportContentBlock>
            <SCRefriverTitle>
              Партнерам
            </SCRefriverTitle>
            <SCRefriverSubTitle>
              — Зарабатывайте с каждой покупки приведенного пользователя
              в течение месяца и используйте заработанные
              средства для покупок на Bookriver.
            </SCRefriverSubTitle>
            <SCRefriverSubTitle>
              — Получайте доход на банковскую карту ежедневно,
              если вы имеете статус ИП или самозанятого
            </SCRefriverSubTitle>
          </SCAuthorsSupportContentBlock>
        </SCRefRiverRow>
      </SCBlock>
      <SCBlock style={{
        display: 'flex', flexDirection: 'column', alignItems: 'center',
      }}
      >
        <SCMarketingItem>
          <SCMarketingIconContainer color="#fbe5d1">
            <SCMarketingIcon
              src="/icon/landing/community/users.svg"
              alt="иконка группы людей"
            />
          </SCMarketingIconContainer>
          <SCMarketingContainer>
            <SCMarketingTitle>
              Для всех пользователей
            </SCMarketingTitle>
            <SCMarketingContent>
              Следите за предложениями авторов на
              {' '}
              <PartnersBooksLink>
                <SCLink>специальной странице</SCLink>
              </PartnersBooksLink>
              {' '}
              , ведь вознаграждение
              на отдельные книги может составить
              {' '}
              <SCBold>до 40%</SCBold>
              {' '}
              . Получайте 10% от площадки с остальных купленных читателем в течение 1 месяца книг
            </SCMarketingContent>
          </SCMarketingContainer>
        </SCMarketingItem>
        <SCMarketingItem>
          <SCMarketingIconContainer color="var(--blue-color)">
            <SCMarketingIcon
              src="/icon/landing/community/pen-blue.svg"
              alt="иконка синей ручки"
            />
          </SCMarketingIconContainer>
          <SCMarketingContainer>
            <SCMarketingTitle>
              Для авторов
            </SCMarketingTitle>
            <SCMarketingContent>
              Рассказывайте о своих и чужих произведениях и получайте:
              {' '}
              <br />
              <SCBold>до 10% от всех покупок</SCBold>
              {' '}
              ваших книг и книг других авторов, которые читатель купит в течение месяца
            </SCMarketingContent>
          </SCMarketingContainer>
        </SCMarketingItem>
        <SCMarketingItem>
          <SCMarketingIconContainer color="#feedc0">
            <SCMarketingIcon
              src="/icon/landing/community/money-yellow.svg"
              alt="иконка мешка с деньгами"
            />
          </SCMarketingIconContainer>
          <SCMarketingContainer>
            <SCMarketingTitle>
              Для коммерческих авторов
            </SCMarketingTitle>
            <SCMarketingContent>
              Приглашайте на площадку других авторов и
              получайте
              {' '}
              <SCBold>5% от их продаж</SCBold>
              {' '}
              в течение 6 месяцев
            </SCMarketingContent>
          </SCMarketingContainer>
        </SCMarketingItem>
      </SCBlock>
      <SCBlock style={{ ['--color' as any]: 'var(--bg-color)' }}>
        <SCFeaturesGrid>
          <SCFeatureCard>
            <SCFeatureIcon
              src="/icon/landing/community/book-blue.svg"
              alt="иконка книг"
            />
            <SCFeatureTitle>
              Вы читатель?
            </SCFeatureTitle>
            <SCFeatureContent>
              Рассказывайте ссылками о любимых авторах и интересных вам
              книгах и зарабатывайте на собственных рекомендациях
            </SCFeatureContent>
          </SCFeatureCard>
          <SCFeatureCard>
            <SCFeatureIcon
              src="/icon/landing/community/pen-blue.svg"
              alt="иконка ручки"
            />
            <SCFeatureTitle>
              Вы автор?
            </SCFeatureTitle>
            <SCFeatureContent>
              Приводите по ссылкам своих читателей и зарабатывайте дополнительно
              с продажи ваших книг и книг других авторов
            </SCFeatureContent>
          </SCFeatureCard>
          <SCFeatureCard>
            <SCFeatureIcon
              src="/icon/landing/community/dialog-blue.svg"
              alt="иконка сообщений"
            />
            <SCFeatureTitle>
              Вы блогер?
            </SCFeatureTitle>
            <SCFeatureContent>
              Размещайте ссылки в статьях, обзорах и подборках и зарабатывайте
              на читателях вашего блога, которые по ним перейдут
            </SCFeatureContent>
          </SCFeatureCard>
          <SCFeatureCard>
            <SCFeatureIcon
              src="/icon/landing/community/chart-blue.svg"
              alt="иконка диаграмм"
            />
            <SCFeatureTitle>
              Вы маркетолог?
            </SCFeatureTitle>
            <SCFeatureContent>
              Добавляйте ссылки в рекламные кампании и тестовые
              посевы и получайте личный доход по ходу работы
            </SCFeatureContent>
          </SCFeatureCard>
          <SCFeatureCard>
            <SCFeatureIcon
              src="/icon/landing/community/window-blue.svg"
              alt="иконка синего окна"
            />
            <SCFeatureTitle>
              Вы владелец сайта?
            </SCFeatureTitle>
            <SCFeatureContent>
              Вставляйте ссылки в материалы на вашем
              сайте и получайте дополнительный способ монетизации
            </SCFeatureContent>
          </SCFeatureCard>
          <SCFeatureCard>
            <SCFeatureIcon
              src="/icon/landing/community/man-in-hat-blue.svg"
              alt="иконка человека в маске"
            />
            <SCFeatureTitle>
              Вы любитель нелегально использовать чужое творчество?
            </SCFeatureTitle>
            <SCFeatureContent>
              Переходите на светлую сторону, используйте легальные
              ссылки в своей деятельности и получайте абсолютно чистый доход
            </SCFeatureContent>
          </SCFeatureCard>
        </SCFeaturesGrid>
        {!isLoggedIn && (
          <SCRow>
            <SCButton
              onClick={
                () => dispatch(openModal('login'))
              }
            >
              Присоединиться
            </SCButton>
          </SCRow>
        )}
      </SCBlock>
      <SCFAQWrapper>
        <SCFAQ>
          <SCFAQTitle>
            Ответы на часто задаваемые вопросы
          </SCFAQTitle>
          <SCFAQAccordions>
            <SCAccordion
              title={(
                <SCFAQAccordionTitle>
                  Как зарегистрироваться и начать зарабатывать?
                </SCFAQAccordionTitle>
              )}
              content={(
                <SCFAQACcordionText>
                  <ol>
                    <li>
                      Никаких сложных регистрационных форм. Всего один клик.
                      И вы становитесь пользователем сайта и партнерской программы одновременно.
                    </li>
                    <li>
                      Зарегистрированные пользователи увидят особые ссылки на каждой страничке.
                    </li>
                    <li>
                      Специальные предложения от авторов, с повышенным вознаграждением (до 40%)
                      на определенный период, будут появляться автоматически на отдельной странице.
                    </li>
                    <li>
                      Ссылка есть на любой странице сайта. Рассказывайте о книге,
                      авторе, жанре, интересной статье. Это разнообразит ваши рассылки,
                      их количество не ограничено.
                    </li>
                    <li>
                      Чтобы заработать на книгах, их нужно размещать ссылки в ваших соцсетях,
                      блогах, на сайтах, посылать в письмах или мессенджерах.
                    </li>
                    <li>
                      И целый месяц получать вознаграждения, указанные на ссылке,
                      за покупки новых пользователей, пришедших по этим ссылкам.
                    </li>
                  </ol>
                  <p>
                    <strong>
                      Рассылать ссылки Bookriver и получать вознаграждение могут
                      только зарегистрированные пользователи старше 18 лет.
                    </strong>
                  </p>
                </SCFAQACcordionText>
              )}
            />
            <SCAccordion
              title={(
                <SCFAQAccordionTitle>
                  Как получить заработанные средства?
                </SCFAQAccordionTitle>
              )}
              content={(
                <SCFAQACcordionText>
                  <p>
                    <ol>
                      <li>
                        Заработанные средства можно вывести на банковскую карту, использовать
                        для собственных покупок на площадке Bookriver или потратить
                        на вознаграждение авторам
                      </li>
                      <li>
                        Для вывода денежных средств на карту необходимо иметь
                        статус самозанятого или ИП. Подробная инструкция по
                        оформлению статуса самозанятого тут. В случае если вы
                        не имеете этого статуса, вы можете использовать заработанные
                        средства для совершения покупок на площадке Bookriver или
                        потратить на вознаграждение любимым авторам
                      </li>
                      <li>
                        Вывод денежных средств осуществляется не чаще одного раза в день.
                        При сумме выплаты меньше 2000 руб. дополнительно взимается комиссия
                        30 руб. за банковскую операцию.
                      </li>
                      <li>
                        Привязать свою банковскую карту, на которую необходимо осуществлять
                        выплаты, вы можете на странице «Личный счет»
                      </li>
                    </ol>
                  </p>
                </SCFAQACcordionText>
              )}
            />
            <SCAccordion
              title={(
                <SCFAQAccordionTitle>
                  Как проверить, сколько я заработал?
                </SCFAQAccordionTitle>
              )}
              content={(
                <SCFAQACcordionText>
                  <p>
                    На странице «Личный счет» на вкладке  можно наблюдать за ходом
                    вашей рекламной кампании и радоваться доходам. Вы будете видеть
                    сколько человек перешли по конкретной ссылке, сколько из них
                    совершило покупки и сколько вы за этом заработали.
                  </p>
                </SCFAQACcordionText>
              )}
            />
            <SCAccordion
              title={(
                <SCFAQAccordionTitle>
                  Как автор может заработать больше с партнерской программой?
                </SCFAQAccordionTitle>
              )}
              content={(
                <SCFAQACcordionText>
                  <ol>
                    <li>
                      Автор может использовать программу, как любой другой пользователь.
                    </li>
                    <li>
                      Для этого нужно делиться ссылками на собственные произведения
                      на персональной страничке в соцсетях, на сайте, рассылать по почте или в
                      мессенджерах и получать кэшбэк от площадки с каждой покупки,
                      которую совершит новый пользователь.
                    </li>
                    <li>
                      Таким же образом автор может поддерживать коллег по
                      цеху и рассказывать об их книгах на своих площадках.
                    </li>
                    <li>
                      Причем получать кэшбэк автор будет как за свои книги,
                      так и за покупку книг других авторов.
                    </li>
                    <li>
                      Таким образом автор имеет возможность значительно снизить
                      комиссионные расходы, которые выплачиваются площадке.
                    </li>
                  </ol>
                </SCFAQACcordionText>
              )}
            />
            <SCAccordion
              title={(
                <SCFAQAccordionTitle>
                  Как размещенная ссылка закрепляется за мной?
                </SCFAQAccordionTitle>
              )}
              content={(
                <SCFAQACcordionText>
                  <ol>
                    <li>
                      Программа автоматически привязывает каждого человека, пришедшего
                      по вашей ссылке, к вашей страничке. Это значит, что
                      никто другой не сможет заработать на вашей ссылке.
                    </li>
                    <li>
                      Ссылка записывается и хранится в течение 30 дней.
                    </li>
                    <li>
                      Таким образом любая покупка, совершенная новым пользователем
                      в течение 30 дней с момента перехода по вашей ссылке,
                      засчитывается вам. При этом пользователь может зайти на наш
                      сайт напрямую, через поисковую систему или из закладок.
                    </li>
                    <li>
                      Через 30 дней ссылка автоматически открепляется.
                    </li>
                  </ol>
                </SCFAQACcordionText>
              )}
            />
            <SCAccordion
              title={(
                <SCFAQAccordionTitle>
                  Как автор может использовать программу для продвижения своих книг?
                </SCFAQAccordionTitle>
              )}
              content={(
                <SCFAQACcordionText>
                  <p>
                    Для продвижения автор может рассказывать о книгах, размещенных
                    на Bookriver своей читательской аудитории, а также договариваться
                    с владельцами сайтов, каналов, площадок, блогов, групп в социальных
                    сетях о повышенном вознаграждении за размещение и продвижение своих
                    произведений с помощью ссылок Bookriver, с оплатой из прибыли.
                    Подробнее читайте здесь.
                  </p>
                </SCFAQACcordionText>
              )}
            />
          </SCFAQAccordions>
        </SCFAQ>
      </SCFAQWrapper>
      <SCSocials>
        <SCRow>
          <SCDevelopmentTitleH2>
            Хотите быть в курсе развития проекта?
          </SCDevelopmentTitleH2>
        </SCRow>
        <SCRow>
          <SCDevelopmentSubTitleH3>
            Подписывайтесь на сообщества в соцсетях
          </SCDevelopmentSubTitleH3>
        </SCRow>
        <SCRow style={{ marginBottom: '140px' }}>
          <SCSocialLinks>
            <a
              href="https://vk.com/bookriverru"
              target="_blank"
              rel="noopener noreferrer"
            >
              <SCSocialIcon
                src="/icon/landing/im-author/vk.svg"
                width={64}
                height={64}
                alt="иконка вконтакте"
              />
            </a>
          </SCSocialLinks>
        </SCRow>
        <SCCurve />
      </SCSocials>
    </SCRefriver>
  );
};

const SCSocialIcon = styled.img`
  width: 64px;
  height: 64px;
`;

const SCBlock = styled.section`
  position: relative;
  padding: 100px;
  width: 100%;
  max-width: 1400px;
  
  background-color: var(--color);
  
  ${lessThan('md')} {
    padding: 50px;
  }

  ${lessThan('sm')} {
    padding: 50px 8px;
  }
`;

const SCSocials = styled(SCBlock)` && {
    background-color: #2D3848;
    max-width: none;
  }
`;

const SCSocialLinks = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
`;

const SCMarketingIcon = styled.img`
  width: 48px;
  height: 48px;
`;

const SCMarketingIconContainer = styled.div<{ color?: string }>`
  border-radius: 30px;
  width: 100px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 82px;
  flex-shrink: 0;
  
  background-color: ${({ color }) => (color ?? '#fff')};

  ${lessThan('sm')}{
    margin-right: unset;
    margin-bottom: 16px;
  }
`;

const SCMarketingTitle = styled.h3`
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 24px;

  color: #252829;

  ${lessThan('sm')}{
    font-size: 16px;
    line-height: 24px;
    text-align: center;
  }
`;

const SCMarketingContent = styled.span`
  font-family: var(--landing-font);
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;

  color: var(--gray-color);

  ${lessThan('sm')}{
    text-align: center;
    font-size: 15px;
    line-height: 20px;
    max-width: 300px;
  }
`;

const SCMarketingContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 652px;
`;

const SCMarketingItem = styled.section`
  display: flex;
  flex-direction: row;
  margin-bottom: 80px;
  margin-left: auto;
  margin-right: auto;

  &:last-of-type {
    margin-bottom: unset;
  }

  ${lessThan('sm')}{
    flex-direction: column;
    align-items: center;
    margin-bottom: 50px;
  }
`;

const SCDevelopmentTitleH2 = styled.h2`
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 32px;
  line-height: 48px;
  margin-bottom: 5px;

  text-align: center;

  color: #FFFFFF;

  ${lessThan('sm')} {
    font-size: 24px;
    line-height: 36px;
  }
`;

const SCDevelopmentSubTitleH3 = styled.h3`
  font-family: var(--landing-main-font);

  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 28px;

  display: flex;
  align-items: center;
  text-align: center;
  
  margin-bottom: 52px;
  max-width: 530px;

  color: var(--gray-color);

  ${lessThan('sm')} {
    font-size: 20px;
    line-height: 26px;
  }
`;

const SCFeatureIcon = styled.img`
  width: 48px;
  height: 48px;
  margin-bottom: 26px;
  
  ${lessThan('sm')} {
    width: 32px;
    height: 32px;
    margin-bottom: 24px;
  }
`;

const SCFeatureContent = styled.span`
  font-family: var(--landing-font);
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;

  color: var(--gray-color);

  flex: none;
  order: 1;
  flex-grow: 0;
  
  ${lessThan('sm')} {
    font-size: 15px;
    line-height: 22px;
  }
`;

const SCFeatureTitle = styled.h2`
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;

  color: var(--black-color);

  flex: none;
  order: 0;
  flex-grow: 0;
  margin-bottom: 16px;

  ${lessThan('sm')} {
    font-size: 16px;
    line-height: 20px;
  }
`;

const SCFeatureCard = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 375px;
  height: 340px;
  padding: 30px;
  background-color: white;
  box-shadow: 0 1px 1px rgba(141, 147, 162, 0.25);
  border-radius: 12px;

  ${lessThan('sm')}{
    border-radius: 12px;
    width: 310px;
    height: 260px;
    padding: 23px;
  }
`;

const SCFeaturesGrid = styled.div`
  display: grid;
  justify-content: center;
  grid-column-gap: 36px;
  grid-row-gap: 27px;
  grid-template-columns: repeat(auto-fill, 375px);
  
  ${lessThan('sm')}{
    grid-template-columns: repeat(auto-fill, 310px);
    grid-column-gap: 8px;
    grid-row-gap: 12px;
  }
`;

const SCHeroTitleH1 = styled.h1`
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
  line-height: 48px;
  color: #fff;

  ${lessThan('sm')} {
    font-size: 30px;
    line-height: 32px;
    text-align: center;
    max-width: 410px;
  }
`;

const SCHeroTitleH2 = styled.h2`
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 36px;
  line-height: 48px;
  color: #fff;
  
  ${lessThan('sm')} {
    font-size: 24px;
    line-height: 30px;
    text-align: center;
    max-width: 410px;
  }
`;

const SCHeroBlockHeaders = styled.div`
  text-align: center;
  max-width: 780px;
  margin: 0 auto;
`;

const SCHeroBlockContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: flex;
  align-items: center;
  padding: 100px;

  ${lessThan('sm')} {
    justify-content: center;

    padding: unset;
    padding: 50px;
  }

  ${lessThan('xs')} {
    padding: 25px;
  }
`;

const SCHeroBlock = styled.section`
  position: relative;
  width: 100%;
  max-width: 1400px;
  background-image: url('/image/community-hero.jpg');
  background-size: cover;
  background-position: 35% center;
  height: 571px;
  
  ${lessThan('xl')} {
    padding-top: 38.15%;
    height: unset;
    min-height: 440px;
  }
`;

const SCButton = styled.button`
  background: var(--primary-color);
  border-radius: 40px;
  font-family: var(--main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: var(--white-color);
  padding: 20px 36px;
  border: unset;
  cursor: pointer;
  
  &:focus {
    outline: unset;
  }
  
  &:hover {
    background: var(--primary-hover-color);
    color: var(--white-color);
  }

  ${lessThan('md')} {
    font-size: 18px;
    line-height: 24px;
    padding: 16px 26px;
  }
`;

const SCCurve = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 119px;
  background-image: url('/image/curve.svg');
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center top;
`;

const SCSmallText = styled.p`
  font-family: var(--main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 26px;
  color: var(--black-color);

  ${lessThan('md')} {
    text-align: center;
    font-size: 15px;
    line-height: 20px;
  }

  ${lessThan('sm')} {
    font-size: 18px;
    line-height: 26px;
  }
`;

const SCStatisticsContainer = styled.div`
  margin-right: 90px;
  position: relative;
  width: 100%;
  max-width: 350px;
  flex-shrink: 0;

  ${lessThan('md')} {
    margin-right: 40px;
    max-width: 320px;
  }

  ${lessThan('sm')} {
    margin-right: 0;
    height: 330px;
  }
`;

const SCSCStatisticsMain = styled.div`
  position: absolute;
  background: var(--yellow-color);
  width: 248px;
  height: 248px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px;
  right: 0;
  top: 60px;
  flex-direction: column;
  border-radius: 50%;

  ${lessThan('md')} {
    top: 80px;
  }
`;

const SCSCStatisticsMainTitle = styled.div`
  font-family: var(--landing-font);
  font-weight: bold;
  font-size: 48px;
  line-height: 50px;
  color: var(--black-color);
  `;

const SCSCStatisticsMainDescription = styled.div`
  font-family: var(--landing-font);
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  text-align: center;
  text-transform: uppercase;
  padding-top: 6px;
  color: var(--black-color);
`;

const SCSCStatisticsSecond = styled.div`
  position: absolute;
  background: rgb(87 210 253 / 28%);
  width: 152px;
  height: 152px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  left: 0;
  top: 0;
  flex-direction: column;
  border-radius: 50%;
`;

const SCSCStatisticsSecondTitle = styled.div`
  font-family: var(--landing-font);
  font-weight: bold;
  font-size: 24px;
  line-height: 26px;
  color: var(--black-color);
`;

const SCSCStatisticsSecondDescription = styled.div`
  font-family: var(--landing-font);
  font-weight: bold;
  font-size: 10px;
  line-height: 16px;
  text-align: center;
  text-transform: uppercase;
  padding-top: 2px;
  color: var(--black-color);
`;

const SCSmallBoldText = styled.span`
  font-family: var(--main-font);
  font-style: normal;
  font-size: 18px;
  line-height: 24px;
  font-weight: 600;
  color: var(--black-color);
`;

const SCParagraph = styled.p`
  margin-top: 28px;
  
  ${SCSmallBoldText} {
    display: block;
    padding-left: 40px;
  }
`;

const SCSmallTitle = styled.h4`
  font-family: var(--landing-main-font);;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 24px;
  margin-bottom: 32px;
  position: relative;
  
  color: var(--black-color);

  ${lessThan('md')} {
    text-align: center;
    font-size: 16px;
    line-height: 24px;
  }
`;

const SCRefriverTitle = styled.h2`
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: bold;
  font-size: 48px;
  line-height: 48px;
  margin-bottom: 40px;

  color: #2D3848;
  
  ${lessThan('sm')} {
    font-size: 24px;
    line-height: 36px;
    text-align: center;
    margin-bottom: 25px;
  }
`;

const SCRefriverSubTitle = styled.h6`
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
  
  color: #2D3848;

  ${lessThan('sm')} {
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    max-width: 270px;
    margin-left: auto;
    margin-right: auto;
  }

  &:not(:last-child) {
    margin-bottom: 24px;
  }
`;

const SCAuthorsSupportContentBlock = styled.section`
  max-width: 500px;
  margin-top: auto;
  margin-bottom: auto;
  
  ${SCParagraph} {
    position: relative;
  }
  
  ${SCSmallTitle} {
    margin-bottom: 32px;
  }
  
  ${SCSmallText} {
    position: relative;
    padding-left: 50px;
    margin-bottom: 28px;
    
    img {
      position: absolute;
      left: -26px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  
  ${SCSmallBoldText} {
    position: relative;
    z-index: 2;
  }

  ${lessThan('sm')} {
    margin-top: 40px;
    
    ${SCSmallText} {
      display: flex;
      align-items: center;
      flex-direction: column;
      padding-left: unset;
      font-size: 20px;
      line-height: 28px;

      img {
        position: relative;
        left: unset;
        top: unset;
        transform: unset;
        margin-bottom: 8px;
      }
    }
    
  }
`;

const SCRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;

const SCRefRiverRow = styled(SCRow)`
  ${lessThan('sm')} {
    flex-direction: column;
    align-items: center;
  }
`;

const SCRefriver = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-x: hidden;
`;

const SCBold = styled.b`
  font-weight: 900;
  color: var(--black-color);
`;

const SCFAQ = styled.div`
  position: relative;
  padding: 100px;
  width: 100%;
  max-width: 1400px;

  ${lessThan('md')} {
    padding: 50px;
  }

  ${lessThan('sm')} {
    padding: 50px 12px;
  }
`;

const SCFAQTitle = styled.h2`
  margin: 0;
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 40px;
  line-height: 48px;
  color: var(--black-color);

  ${lessThan('sm')} {
    font-size: 26px;
    line-height: 30px;
  }
`;

const SCFAQWrapper = styled.div`
  background: #fff;
  width: 100%;
  display: flex;
  justify-content: center;
`;

const SCFAQAccordions = styled.div`
  margin-top: 40px;

  ${lessThan('sm')} {
    margin-top: 20px;
  }
`;

const SCFAQAccordionTitle = styled.h3`
  margin-bottom: 0;
  font-family: var(--landing-main-font);
  font-style: normal;
  font-weight: normal;
  font-size: 20px;
  line-height: 28px;
`;

const SCFAQACcordionText = styled.div`
  font-family: var(--landing-font);
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
`;

const SCAccordion = styled(Accordion)`
  border-bottom: 1px solid #e8ecee;
`;

const SCLink = styled.a`
  color: var(--primary-color);
  font-size: inherit;
  font-family: inherit;
  font-weight: inherit;
  line-height: inherit;
`;
